import { Box, Button, Grid, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Navigate, useNavigate } from 'react-router-dom';
import useAuth from '../../../lib/api/auth/useAuth';
import {
  CategoryQueryKeys,
  getAllCategories,
} from '../../../lib/api/categories/categories.service';
import CategoryProductList from '../expandable-rows/CategoryProductList';
import StoreCategoryRow from '../expandable-rows/StoreCategoryRow';
import CartSummary from '../../../components/cart-summary/CartSummary';
import StoreClosed from './StoreClosed';
import { useCartContext } from '../../../contexts/CartContext';
import { downloadStoreAvailability } from '../../../lib/common/report-download.service';
import ReactMarkdown from 'react-markdown';

export default function StorePageCustomer() {
  const { authed } = useAuth();
  const { storeStatus } = useCartContext();
  const navigate = useNavigate();

  const {
    isError: categoriesIsError,
    data: categoriesRes,
    error: categoriesError,
    isFetching: categoriesIsFetching,
  } = useQuery([CategoryQueryKeys.findAllCategories], () => getAllCategories());

  if (!authed()) return <Navigate to="/auth/login" />;
  if (!storeStatus) return null;

  if (!storeStatus.inWindow) return <StoreClosed storeStatus={storeStatus} />;

  return (
    <>
      <Typography variant="h3" component="h1">
        Availability for Week of{' '}
        {new Date(storeStatus.currentWeek.closeAt).toLocaleString('en-US', {
          weekday: 'long',
          month: 'short',
          day: 'numeric',
        })}
      </Typography>
      <Grid container spacing={4}>
        {storeStatus.featureNote && (
          <Grid
            item
            sm={12}
            md={7}
            sx={{ position: 'sticky', top: '70px', zIndex: 1000 }}
          >
            <Box
              sx={{
                backgroundColor: 'grey.200',
                borderRadius: 1,
                padding: 1,
                marginBottom: 2,
                '& p:first-of-type': { marginTop: 0 },
                '& p:last-of-type': { marginBottom: 0 },
              }}
            >
              <ReactMarkdown
                components={{
                  a: ({ href, children, ...props }) => (
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      {...props}
                    >
                      {children}
                    </a>
                  ),
                }}
              >
                {storeStatus.featureNote}
              </ReactMarkdown>
            </Box>
          </Grid>
        )}
        <Grid item sm={12} md={7}>
          <Button
            variant="outlined"
            sx={{ mt: 2, mb: 2 }}
            onClick={downloadStoreAvailability}
          >
            Download Availability
          </Button>
          {categoriesRes?.data?.map((category) => (
            <StoreCategoryRow
              key={`category-${category.id}`}
              category={category}
              expandedComponent={<CategoryProductList category={category} />}
            />
          ))}
        </Grid>
        <Grid
          item
          sm={12}
          md={5}
          sx={{
            height: '100%',
            // For screens larger than 900px, use fixed positioning
            '@media (min-width: 900px)': {
              position: 'fixed',
              top: '150px',
              right: '0',
              height: 'calc(100vh + 50px)',
              overflowY: 'scroll',
            },
          }}
        >
          <CartSummary onCheckout={() => navigate('/cart')} />
        </Grid>
      </Grid>
    </>
  );
}
